import React, { PropsWithChildren } from 'react'

import ExternalLink from '@components/shared/ExternalLink'
import messagesAvatar from '@images/messages_avatar.png'
import AccountAlert from '@models/AccountAlert'
import { formatRelativeTime } from '@utils/formatters/date.formatter'

interface Props {
  alert: AccountAlert
}

const AlertCard: React.FC<PropsWithChildren<Props>> = ({ alert, children }) => {
  return (
    <div
      className="py-1 px-2.5 bg-white dark:bg-black-bg2 rounded relative flex flex-row mb-1"
      key={alert.id}>
      <ExternalLink href="/" className="mr-2">
        <div className="h-[40px] w-[40px] overflow-hidden rounded-full">
          <img src={messagesAvatar} alt="Noteflight" />
        </div>
      </ExternalLink>
      <div className="flex flex-col p-1">
        <ExternalLink href="/" className="underline-link ellipsify mr-1">
          Noteflight
        </ExternalLink>
        <span className="text-xs text-gray-text dark:text-gray-text-dm mb-2">
          {formatRelativeTime(alert.date, new Date())}
        </span>
        <div>{children}</div>
      </div>
    </div>
  )
}

export default AlertCard
